/**
 * 시너지 강화 레벨 — `synergyId → level(>=1)` 맵.
 *
 * 시너지는 발견으로 잠금 해제되는 보상이 아니라, 정의가 항상 보이는 조합 효과다.
 * 이 컨트롤러는 강화석으로 올린 효과 레벨만 영속한다.
 */
export class SynergyLevelController {
  private readonly levels = new Map<string, number>();

  constructor(initial?: Record<string, number>) {
    if (initial) {
      for (const [id, lv] of Object.entries(initial)) {
        if (typeof lv === "number" && Number.isFinite(lv) && lv > 1) {
          this.levels.set(id, Math.floor(lv));
        }
      }
    }
  }

  /** 미강화 시너지는 Lv1. */
  level(synergyId: string): number {
    return this.levels.get(synergyId) ?? 1;
  }

  /** 레벨 +1 후 새 레벨 반환. 재료 차감은 호출자 책임. */
  upgrade(synergyId: string): number {
    const next = this.level(synergyId) + 1;
    this.levels.set(synergyId, next);
    return next;
  }

  /** 치트/테스트용 직접 설정. */
  setLevel(synergyId: string, level: number): void {
    this.levels.set(synergyId, Math.max(1, Math.floor(level)));
  }

  clear(): void {
    this.levels.clear();
  }

  /** 기본 Lv1은 생략한다. */
  toState(): Record<string, number> {
    const out: Record<string, number> = {};
    for (const [id, lv] of this.levels) {
      if (lv > 1) out[id] = lv;
    }
    return out;
  }

  static fromState(state: Record<string, number> | undefined): SynergyLevelController {
    return new SynergyLevelController(state);
  }
}
